module.exports = __webpack_public_path__ + "static/media/water.1d65e2fd.jpg";